












































































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

@Component({
  components: {
  }
})
export default class Relate extends Vue {

  isLogin = false
  selectedCategory = "Twitter"

  private onOk() {
    this.$emit("close");
  }

  //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

}
